import { useEffect } from 'react'
import { UI_STRINGS, type UiLocale, type UiStrings } from '@/constants/ui-locale'
import { useStore } from '@/store/useStore'

export function useUiStrings(): { t: UiStrings; locale: UiLocale } {
  const locale = useStore((s) => s.uiLocale)
  return { t: UI_STRINGS[locale], locale }
}

export function useLocaleSync(): void {
  const locale = useStore((s) => s.uiLocale)

  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])
}
